import { SCHEDULING_SCHEDULED_MEMBER_FRAGMENT } from 'containers/scheduling/apollo/scheduling-fragments';
import gql from 'graphql-tag';

export const QUERY_SCHEDULE_REMINDERS = gql`
  query ScheduleReminders(
    $filter: ScheduleReminderFilter
    $sort: [ScheduleReminderSort!]
    $first: Int
    $after: String
  ) {
    scheduleReminders(filter: $filter, sort: $sort, first: $first, after: $after) {
      id
      organizationId
      memberId
      startTime
      endTime
      payload
      type
      createdOn
      cursor
      notifyEmployee
      project {
        id
        title
        depth
        projectGroupId
        parentProjectId
        rootProjectId
        archivedOn
        ancestors {
          id
          title
          depth
          projectGroupId
          archivedOn
        }
        projectCostCodeLink {
          id
          costCodeId
          deletedOn
        }
      }
      costCode {
        archivedOn
        costCode
        costCodeGroupId
        id
        title
      }
      equipment {
        archivedOn
        equipmentGroupId
        equipmentName
        id
        model {
          category {
            id
            title
          }
          equipmentCategoryId
          equipmentMakeId
          id
          make {
            id
            title
          }
          modelNumber
          title
          year
        }
      }
      links {
        id
        scheduleReminderId
        memberId
        member {
          id
          ...SchedulingScheduledMember
        }
      }
    }
  }
  ${SCHEDULING_SCHEDULED_MEMBER_FRAGMENT}
`;

export const QUERY_SCHEDULE_REMINDERS_BASIC_LINKS = gql`
  query ScheduleReminderBasicLinks(
    $filter: ScheduleReminderFilter
    $sort: [ScheduleReminderSort!]
    $first: Int
    $after: String
  ) {
    scheduleReminders(filter: $filter, sort: $sort, first: $first, after: $after) {
      id
      organizationId
      memberId
      startTime
      endTime
      payload
      type
      createdOn
      cursor
      notifyEmployee
      links {
        id
        scheduleReminderId
        memberId
      }
    }
  }
`;
